import { render, staticRenderFns } from "./SessionDetailsCard.vue?vue&type=template&id=0e15fd1c"
import script from "./SessionDetailsCard.vue?vue&type=script&lang=js"
export * from "./SessionDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports